import { ITaskSession, tAnswer } from 'common/modules/ReactShared';
import { useCallback } from 'react';

type tCheckTaskActionsArgs = {
  lessonTaskSession: ITaskSession | null;
  isCompleting: boolean;
  onFinishAndNext(answers?: tAnswer): Promise<void>;
};

type tCheckTaskActions = {
  onNext: (answers: tAnswer) => void;
  onSkip: () => void;
};

const useCheckTaskActions = (args: tCheckTaskActionsArgs): tCheckTaskActions => {
  const { isCompleting, onFinishAndNext, lessonTaskSession } = args;

  const onNext = useCallback(
    (answers: tAnswer) => {
      if (!isCompleting) {
        onFinishAndNext(answers);
      }
    },
    [isCompleting, onFinishAndNext]
  );

  const onSkip = useCallback(() => {
    if (!isCompleting) {
      onFinishAndNext(lessonTaskSession?.taskItemSessions);
    }
  }, [isCompleting, onFinishAndNext, lessonTaskSession]);

  return {
    onNext,
    onSkip
  };
};

export { useCheckTaskActions };
export type { tCheckTaskActions, tCheckTaskActionsArgs };
